import Stack from "@mui/material/Stack";

import { type FC, type PropsWithChildren } from "react";
import { Stepper } from "./Stepper";


export type ModalHeaderProps = PropsWithChildren<{
	hasStepper?: boolean;
	numberOfSteps?: number;
	wideModal?: boolean;
}>

const ModalHeader: FC<ModalHeaderProps> = ({
	children,
	hasStepper,
	numberOfSteps,
	wideModal,
}) => {
	return (
		<Stack
			sx={{
				zIndex: 1,
				boxShadow: "far",
				borderTopLeftRadius: 16,
				borderTopRightRadius: 16,
				backgroundColor: "white.main",
			}}
		>
			<Stack
				direction="row"
				sx={{
					position: "realative",
					justifyContent: "space-between",
					alignItems: "center",
					width: "100%",
					minHeight: wideModal ? "86px" : "64px",
					px: 4,
				}}
			>
				{children}
			</Stack>
			{hasStepper && <Stepper numberOfSteps={numberOfSteps} />}
		</Stack>
	);
};

export default ModalHeader;
